export default __webpack_public_path__ + "media/images/icons/icon_done-158fdbfc997bfbaecd661b95ac707663.svg";